'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var version = require('../version.js');

var multiaddr = require('multiaddr');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var toString = require('uint8arrays/to-string');

var PeerId = require('peer-id');

var errors = require('../errors.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var PeerId__default = /*#__PURE__*/_interopDefaultLegacy(PeerId);

function createId(_ref) {
  var peerId = _ref.peerId,
      network = _ref.network;

  function id() {
    return _id.apply(this, arguments);
  }

  function _id() {
    _id = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var options,
          net,
          _idStr,
          id,
          libp2p,
          publicKey,
          addresses,
          protocols,
          agentVersion,
          protocolVersion,
          idStr,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};

              if (options.peerId === peerId.toB58String()) {
                delete options.peerId;
              }

              net = network.try();

              if (net) {
                _context.next = 8;
                break;
              }

              if (!options.peerId) {
                _context.next = 6;
                break;
              }

              throw new errors.NotStartedError();

            case 6:
              _idStr = peerId.toB58String();
              return _context.abrupt("return", {
                id: _idStr,
                publicKey: toString.toString(peerId.pubKey.bytes, 'base64pad'),
                addresses: [],
                agentVersion: "js-ipfs/".concat(version.ipfsCore),
                protocolVersion: '9000',
                protocols: []
              });

            case 8:
              id = options.peerId ? PeerId__default["default"].createFromB58String(options.peerId.toString()) : peerId;
              libp2p = net.libp2p;
              publicKey = options.peerId ? libp2p.peerStore.keyBook.get(id) : id.pubKey;
              addresses = options.peerId ? libp2p.peerStore.addressBook.getMultiaddrsForPeer(id) : libp2p.multiaddrs;
              protocols = options.peerId ? libp2p.peerStore.protoBook.get(id) : Array.from(libp2p.upgrader.protocols.keys());
              agentVersion = toString.toString(libp2p.peerStore.metadataBook.getValue(id, 'AgentVersion') || new Uint8Array());
              protocolVersion = toString.toString(libp2p.peerStore.metadataBook.getValue(id, 'ProtocolVersion') || new Uint8Array());
              idStr = id.toB58String();
              return _context.abrupt("return", {
                id: idStr,
                publicKey: toString.toString(publicKey.bytes, 'base64pad'),
                addresses: (addresses || []).map(function (ma) {
                  var str = ma.toString();

                  if (str.endsWith("/p2p/".concat(idStr))) {
                    return str;
                  }

                  return "".concat(str, "/p2p/").concat(idStr);
                }).sort().map(function (ma) {
                  return new multiaddr.Multiaddr(ma);
                }),
                agentVersion: agentVersion,
                protocolVersion: protocolVersion,
                protocols: (protocols || []).sort()
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _id.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(id);
}

exports.createId = createId;